import { z } from "zod";

const messages = {
  requiredField: "Campo obrigatório",
  minCharacters: (num) => `Mínimo de ${num} caracteres`,
  maxCharacters: (num) => `Máximo de ${num} caracteres`,
  invalidEmail: "E-mail inválido",
  invalidURL: "URL inválida",
  invalidDate: "Data inválida",
};

const ContactValidator = {
  name: z
    .string()
    .min(2, { message: messages.minCharacters(2) })
    .max(100, { message: messages.maxCharacters(100) }),
  email: z.string().email({ message: messages.invalidEmail }),
  phone: z
    .string()
    .min(8, { message: messages.minCharacters(8) })
    .max(20, { message: messages.maxCharacters(20) }),
  message: z
    .string()
    .min(5, { message: messages.minCharacters(5) })
    .max(255, { message: messages.maxCharacters(255) }),
};

export default ContactValidator;
